module.exports = __webpack_public_path__ + "static/statue4-3eac85e500a5ff4a3701f7289a40e422.jpg";